import HelpIcon from '@mui/icons-material/Help';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { BooleanField, BooleanInput, Create, Datagrid, Edit, EditButton, FormTab, List, NumberField, NumberInput, SelectInput, Show, ShowActions, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, required, usePermissions, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import OptionReferenceField from 'utils/GeneratedRaReference/OptionReferenceField';
import OptionReferenceInput from 'utils/GeneratedRaReference/OptionReferenceInput';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import TinyMCEInput from 'utils/react-admin/inputs/TinyMCEInput';
import { Permissions } from '../../ra-php-crud-api-auth';

export const CHOICES_QUESTIONS_TITLE = [
  { id:'Mr', name: 'mr', },
  { id:'Ms', name: 'ms', },
];
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <BooleanInput source="is_public" fullWidth />,
  <NumberInput source="position" fullWidth />,
  <OptionReferenceInput source="question_category_id" fullWidth filter={{ option_type: 'question_category' }} />,
  <TextInput source="name" fullWidth />,
  <SelectInput source="title" fullWidth choices={CHOICES_QUESTIONS_TITLE} />,
  <TextInput source="contact" fullWidth />,
  <TextInput source="email" fullWidth />,
  <TextInput source="question_en" fullWidth />,
  <TextInput source="question_tc" fullWidth />,
  <TextInput source="question_sc" fullWidth />,
  <TextInput source="answer_en" fullWidth />,
  <TextInput source="answer_tc" fullWidth />,
  <TextInput source="answer_sc" fullWidth />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateIsPublic: any[] = [required()];
const validatePosition: any[] = [];
const validateQuestionCategoryId: any[] = [required()];
const validateName: any[] = [];
const validateTitle: any[] = [];
const validateContact: any[] = [];
const validateEmail: any[] = [];
const validateQuestionEn: any[] = [];
const validateQuestionTc: any[] = [];
const validateQuestionSc: any[] = [];
// const validateAnswerEn: any[] = [];
// const validateAnswerTc: any[] = [];
// const validateAnswerSc: any[] = [];

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} exporter={XlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.name} (#${record.id})`}
        ></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <BooleanField source="is_public" fullWidth />
            <NumberField source="position" fullWidth />
            <OptionReferenceField source="question_category_id" fullWidth />
            <TextField source="name" fullWidth />
            <TextField source="title" fullWidth />
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <BooleanField source="is_public" fullWidth />
        <NumberField source="position" fullWidth />
        <OptionReferenceField source="question_category_id" fullWidth />
        <TextField source="name" fullWidth />
        <TextField source="title" fullWidth />
        <TextField source="contact" fullWidth />
        <TextField source="email" fullWidth />
        <TextField source="question_en" fullWidth />
        <TextField source="question_tc" fullWidth />
        <TextField source="question_sc" fullWidth />
        <TextField source="answer_en" fullWidth />
        <TextField source="answer_tc" fullWidth />
        <TextField source="answer_sc" fullWidth />
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean}) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={6}><BooleanInput source="is_public" fullWidth validate={validateIsPublic} /></Grid>
          <Grid item xs={6}><NumberInput source="position" fullWidth validate={validatePosition} /></Grid>
          <Grid item xs={12}><OptionReferenceInput source="question_category_id" fullWidth filter={{ option_type: 'question_category' }} validate={validateQuestionCategoryId} /></Grid>
          <Grid item xs={3}><TextInput source="name" fullWidth validate={validateName} /></Grid>
          <Grid item xs={3}><SelectInput source="title" fullWidth choices={CHOICES_QUESTIONS_TITLE} validate={validateTitle} /></Grid>
          <Grid item xs={3}><TextInput source="contact" fullWidth validate={validateContact} /></Grid>
          <Grid item xs={3}><TextInput source="email" fullWidth validate={validateEmail} /></Grid>
          <Grid item xs={4}><TextInput multiline={true} minRows={3} maxRows={5} source="question_en" fullWidth validate={validateQuestionEn} /></Grid>
          <Grid item xs={4}><TextInput multiline={true} minRows={3} maxRows={5} source="question_tc" fullWidth validate={validateQuestionTc} /></Grid>
          <Grid item xs={4}><TextInput multiline={true} minRows={3} maxRows={5} source="question_sc" fullWidth validate={validateQuestionSc} /></Grid>
          <Grid item xs={12}><TinyMCEInput source="answer_en" fullWidth /></Grid>
          <Grid item xs={12}><TinyMCEInput source="answer_tc" fullWidth /></Grid>
          <Grid item xs={12}><TinyMCEInput source="answer_sc" fullWidth /></Grid>
        </GridWrapper>
      </FormTab>
    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: HelpIcon,
}

export default Resource;
